import { render } from "./MPromotionRules.vue?vue&type=template&id=cf931d70&scoped=true"
import script from "./MPromotionRules.vue?vue&type=script&lang=js"
export * from "./MPromotionRules.vue?vue&type=script&lang=js"

import "./MPromotionRules.vue?vue&type=style&index=0&id=cf931d70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf931d70"]])

export default __exports__